<template>
  <header>
    <!-- Logo and contact info -->
    <div
      class="flex items-center justify-center pt-4 text-sm font-light text-txt-strong md:justify-between"
      :class="[contentWidthClass, { 'px-2': isContentFullWidth }]"
    >
      <WebccCompanyLogo
        target="_self"
        :anchor="false"
        :caption="logoCaption"
        class="hidden md:block"
        :href="logoHref"
        @click="trackingLogo()"
      />
      <aside
        v-if="siteSettings?.includes('contactinfo')"
        class="pointer-events-none flex items-center"
      >
        <span class="pointer-events-auto">{{
          $t(`${trPrefix}hereForYou`)
        }}</span>
        <WebccLink
          v-if="showContactUs && links?.contact?.href"
          :to="links.contact.href"
          class="pointer-events-auto ml-3 underline underline-offset-1"
          @click="trackContactUs"
        >
          <span>{{ $t(`${trPrefix}contactUs`) }}</span>
        </WebccLink>
      </aside>
    </div>

    <!-- Navigation, Bookmarks, Lang and Currency switcher -->
    <div
      class="flex items-center py-2 pb-4"
      :class="[
        showMenu ? 'justify-between' : 'justify-end',
        contentWidthClass,
        { 'px-2': isContentFullWidth },
      ]"
    >
      <WebccCompanyLogo
        target="_self"
        :anchor="false"
        :caption="logoCaption"
        class="mr-auto md:hidden"
        :href="logoHref"
        @click="tracking.handlers?.header.headerItemClick('homepage')"
      />
      <Navigation
        v-if="showMenu && header?.menu"
        :menu="header?.menu"
        :links="links"
      />
      <div
        v-if="!isFreeweek"
        class="flex items-center ml-4 md:items-end gap-2 md:gap-3"
      >
        <WishlistLink minimize="md" class="" @click="trackWishlist" />

        <HeaderLangSelect v-if="sites.length > 1" />

        <HeaderSelect
          v-if="currencies && currencies.length > 1"
          :selected-value="confCurrency!"
          :all-options="currencies!"
          :has-key="false"
          :to-upper-case="true"
          @on-change="changeCurrency"
        />

        <!-- Mobile Menu Button -->
        <button
          class="rounded p-1 hover:bg-bgr-100 focus:outline-none active:bg-bgr-100 sm:p-2 md:hidden"
          @click.stop="toggling.toggle('menu')"
        >
          <WebccIcon class="h-7 w-7 text-txt-weak" name="site/menu" />
        </button>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
const trPrefix = 'www.components.site.Header.'

withDefaults(
  defineProps<{
    showMenu?: boolean
    showContactUs?: boolean
  }>(),
  {
    showMenu: true,
    showContactUs: true,
  },
)

const confData = useConfdata()
const tracking = useTracking()
const toggling = useToggler()
const { contentWidthClass, isContentFullWidth } = useContentWidth()

const isFreeweek = useFlag('freeweek')

const logoHref = ref('/')

const {
  header,
  links,
  currencies,
  siteSettings,
  sites,
  logoCaption,
  currency: confCurrency,
} = storeToRefs(confData)

function changeCurrency(currency: string) {
  tracking.handlers?.header.currencySwitch(currency)
  const url = new URL(window.location.href)
  url.searchParams.set('currency', currency)
  window.location.href = url.href
}

function trackingLogo() {
  tracking.handlers?.header.headerItemClick('homepage')
  tracking.handlers?.homepage.headerLogoClick()
}

function trackContactUs() {
  tracking.handlers?.header.headerItemClick('contactus')
  tracking.handlers?.homepage.headerContactUsClick()
}

async function trackWishlist() {
  tracking.handlers?.header.headerItemClick('favourites')
  tracking.handlers?.homepage.headerWishlistClick()
}
</script>
